/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: PGC注册资料个人
 */
"use strict";
angular.module("registerPersonalModule", ["registrationAuditServiceModule"]).
controller("registerPersonalCtrl", ["$scope", "$element", "registrationAuditService", "$modalInstance", "userId", "channelId", "httpService", "modalDialog", "$validation", "checkPhoneAndEmail", function($scope, $element, registrationAuditService, $modalInstance, userId, channelId, httpService, modalDialog, $validation, checkPhoneAndEmail) {
	initStatus();
	initData();

	function initStatus() {
		$scope.headPic = ''; //头像
		$scope.idCardPic = ''; //身份证
		$scope.status = {
			oldPhone: '', //存储手机号的值，用于校验是否重复
			oldEmail: '', //存储邮箱的值，用于校验是否重复
			m: false, //控制页面上手机号码重复提示的显示或隐藏
			e: false, //控制页面上邮箱号码重复提示的显示或隐藏
			mb: false, //控制页面上手机号input框变红的样式
			eb: false, //控制页面上邮箱input框变红的样式
			t: true, //存储校验是否通过的值,
			selectedTypeOptions: [{
				name: '个人',
				value: 0
			}, {
				name: '媒体',
				value: 1
			}, {
				name: '国家机构',
				value: 2
			}, {
				name: '企业',
				value: 3
			}, {
				name: '其他组织',
				value: 4
			}],
			allType: {
				0: '个人',
				1: '媒体',
				2: '国家机构',
				3: '企业',
				4: '其他组织',
			},
			bankOptions: [{
				name: "选择银行",
				value: 0
			}, {
				name: "工商银行",
				value: 1,
			}, {
				name: "农业银行",
				value: 2,
			}, {
				name: "中国银行",
				value: 3,
			}, {
				name: "建设银行",
				value: 4,
			}, {
				name: "交通银行",
				value: 5,
			}, {
				name: "上海浦东发展银行",
				value: 6,
			}, {
				name: "兴业银行",
				value: 7,
			}, {
				name: "光大银行",
				value: 8,
			}, {
				name: "深圳发展银行",
				value: 9,
			}, {
				name: "民生银行",
				value: 10,
			}, {
				name: "中信银行",
				value: 11,
			}, {
				name: "招商银行",
				value: 12,
			}, {
				name: "广东发展银行",
				value: 13,
			}, {
				name: "华夏银行",
				value: 14,
			}],
		};
		$scope.status.selectedBank = angular.copy($scope.status.bankOptions[0]);
		$scope.data = {
			userId: userId,
			channelId: channelId
		}
		$scope.userinfo = {};
	};
	$scope.confirm = function() {
		$validation.validate($scope.createForm).success(function() {
			if($scope.status.t) {
				modalDialog.backConfirmModal("审核通过", "确认通过该用户的资料审核？", function() {
					$scope.userinfo.bankName = $scope.status.selectedBank.value;
					$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/userAuditPass.do", $scope.userinfo, "post").then(function(data) {
						modalDialog.alertType('', '通过成功', 'success');
						$modalInstance.close();
					});
				});
			}
		}).error(function() {
			angular.invalidPosition($scope.createForm, $element);
		});

	};
	$scope.cancel = function() {
		$modalInstance.dismiss();
	};
	$scope.regAuditFail = function() {
		registrationAuditService.regAuditFail(userId, channelId).then(function(data) {
			$scope.userinfo.reason = data.reason;
			$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/userAuditFail.do", $scope.userinfo, "post").then(function(data) {
				modalDialog.alertType('', '注册审核未通过', 'success');
				$modalInstance.close();
			});
		});
	}

	function initData() {
		requestData()
	}

	function requestData() {
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/getAuditUserInfo.do", $scope.data, "post").then(function(data) {
			var d = data.user;
			$scope.userinfo = {
				userId: d.id,
				mediaType: d.mediaType,
				accountName: d.accountName,
				accountDesc: d.accountDesc,
				truename: d.truename,
				mobile: d.mobile,
				email: d.email,
				idNumber: d.idNumber,
				bankName: d.bankName,
				logo: d.logo,
				orgCode: d.orgCode,
				province: d.province,
				city: d.city,
				idNumberPic: d.idNumberPic,
				bankCardNumber: d.bankCardNumber,
				alipayCode: d.alipayCode,
				orgName: d.orgName,
				channelId: data.channel.id
			};
			$scope.status.selectedProvince = d.province;
			$scope.status.oldPhone = d.mobile;
			$scope.status.oldEmail = d.email;
			$scope.status.selectedChannel = data.channel;

			if(d.logo == null || d.logo == "") {
				$scope.headPic = "";
			} else {
				$scope.headPic = angular.globalConfig.pictureServer + d.logo;
			}

			if(d.idNumberPic == null || d.idNumberPic == "") {
				$scope.idCardPic = "";
			} else {
				$scope.idCardPic = angular.globalConfig.pictureServer + d.idNumberPic;
			}
			var a = $scope.status.bankOptions;
			for(var i = 0; i < a.length; i++) {
				if(a[i].value == $scope.userinfo.bankName) {
					$scope.status.selectedBank = angular.copy($scope.status.bankOptions[i]);
				}
			}
		});
	};

	/**
	 * [checkMobile description] 检查手机号是否存在
	 * @params {[obj]}[description]参数
	 * @return {[type]} [description]
	 */
	$scope.checkMobile = function(obj) {
		obj.oldValue = $scope.status.oldPhone;
		checkPhoneAndEmail.checkPhone(obj).then(function(data) {
			if(data) {
				$scope.status.t = true;
				$scope.status.m = false;
				$scope.status.mb = false;
			} else {
				$scope.status.t = false;
				$scope.status.m = true;
				$scope.status.mb = true;
			}
		});
	};
	/**
	 * [checkMobile description] 检查邮箱是否存在
	 * @params {[obj]}[description]参数
	 * @return {[type]} [description]
	 */
	$scope.checkEmail = function(obj) {
		obj.oldValue = $scope.status.oldEmail;
		checkPhoneAndEmail.checkEmail(obj).then(function(data) {
			if(data) {
				$scope.status.t = true;
				$scope.status.e = false;
				$scope.status.eb = false;
			} else {
				$scope.status.t = false;
				$scope.status.e = true;
				$scope.status.eb = true;
			}
		});
	};
}]);